export default "__VITE_ASSET__B1t41Lo6__"